<template>
  <div class="container-fluid overflow-auto page-container-h">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data"></bread-crumb>

    <b-tabs
      ref="tabs"
      v-model="search.year"
      pills
      class="mb-4"
      @input="getReportMonthMember()"
    >
      <b-tab
        v-for="(item, index) in options.year"
        :key="index"
        :title="item.label"
      />
    </b-tabs>

    <tables-page
      :tableData="data.table_data"
      :tableFields="data.table_fields"
    ></tables-page>
  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import reportApi from "@/models/API/reportApi";
import TablesPage from "@/components/layouts/TablesPage";

export default {
  name: 'monthlyCount',
  components: {
    BreadCrumb,
    TablesPage
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '報表', url: '', isActive: true },
          { name: '每月件數', url: '', isActive: false }
        ]
      },
      options: {
        year: [],
      },
      search: {
        year: 0
      },
      data: {
        table_data: [],
        table_fields: [
          {
            key: "type",
            label: "類別",
          },
          {
            key: "month_1",
            label: "一月",
          },
          {
            key: "month_2",
            label: "二月",
          },
          {
            key: "month_3",
            label: "三月",
          },
          {
            key: "season_1",
            label: "第一季",
          },
          {
            key: "month_4",
            label: "四月",
          },
          {
            key: "month_5",
            label: "五月",
          },
          {
            key: "month_6",
            label: "六月",
          },
          {
            key: "season_2",
            label: "第二季",
          },
          {
            key: "month_7",
            label: "七月",
          },
          {
            key: "month_8",
            label: "八月",
          },
          {
            key: "month_9",
            label: "九月",
          },
          {
            key: "season_3",
            label: "第三季",
          },
          {
            key: "month_10",
            label: "十月",
          },
          {
            key: "month_11",
            label: "十一月",
          },
          {
            key: "month_12",
            label: "十二月",
          },
          {
            key: "season_4",
            label: "第四季",
          },
          {
            key: "total",
            label: "合計",
          },
        ],
        page: {},
        temp_table_data: {}
      },
    }
  },
  computed: {

  },
  mounted() {
    this.reportApi = new reportApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.generateYearArray();
    },
    // 產生年份陣列資料
    generateYearArray() {
      const currentYear = new Date().getFullYear(); // Get current year in AD
      const startYearROC = 105; // Start year in ROC
      const endYearROC = currentYear - 1911; // End year in ROC

      const yearArray = Array.from({ length: currentYear - (startYearROC + 1911) + 1}, (num, index) => {
        const rocYear = endYearROC - index;
        const adYear = currentYear - index;

        return {
          value: index,
          label: `${rocYear}年`,
          key: adYear,
        };
      });

      this.options.year = yearArray;
      this.getReportMonthMember();
    },
    // 取得每月件數一覽
    getReportMonthMember() {
      const year = this.options.year.find(item => item.value === this.search.year).key;
      const params = {
        year: year
      };

      this.reportApi.getReportMonthMember((response) => {
        const res = response.data;

        this.tableFormatHandler(res.data[0])
      }, params)
    },
    // 表格格式整理
    tableFormatHandler(data) {
      const table_classified_data = {
        add: { type: '新增件', total: 0 },
        dead: { type: '身故件', total: 0 },
        exclusion: { type: '失效件', total: 0 },
        valid_num: { type: '結算有效件', total: 0 }
      };

      const monthsAndSeasons = ['month_1', 'month_2', 'month_3', 'month_4', 'month_5', 'month_6', 'month_7', 'month_8', 'month_9', 'month_10', 'month_11', 'month_12', 'season_1', 'season_2', 'season_3', 'season_4'];

      Object.entries(table_classified_data).forEach(([table_key, table_value]) => {
        monthsAndSeasons.forEach(period => {
          const current_key = `${period}_${table_key}`;
          const add_key = `${period}_add`;
          const dead_key = `${period}_dead`;
          const exclusion_key = `${period}_exclusion`;

          if (table_key === 'valid_num') {
            table_classified_data[table_key][period] = data[add_key] - data[dead_key] - data[exclusion_key];
            table_classified_data[table_key].total += data[add_key] - data[dead_key] - data[exclusion_key];
          } else {
            table_classified_data[table_key][period] = data[current_key];
            table_classified_data[table_key].total += data[current_key];
          }
        });
      });

      this.data.table_data = Object.values(table_classified_data);
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/monthlyCount.vue